import "../.././styles/Constitution.css";
function ArticleFour(){
    return(
        <>
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE IV: GOVERNING BOARD</h3>
                    <h5>4.1 Powers</h5>
                    <p>
                        The Governing Board shall manage the affairs of the corporation in accordance
                        with the resolutions of members in Annual General Meeting and consistent with the
                        objectives of the corporation.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>4.2 Composition</h5>
                    <p>
                        A minimum of nine (9) and not more than fifteen (15) elected persons
                        bearing the title of Directors. In addition to the elected Directors referred in paragraph 2.1,
                        the immediate Past President of the corporation shall serve as an ex-officio member of the
                        Board.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>4.3 Election</h5>
                    <p>
                        All Members of the Governing Board shall be members of the corporation in
                        good standing who shall be elected by the members of the corporation at an Annual
                        General Meeting.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>4.4 Term of Office</h5>
                    <p>
                        Members of the Governing Board are elected for a 3-year term, 2-year
                        term, and 1-year term. One third of the members of the Governing Board starting with
                        those who have been in office for three (3) years since their election, shall retire and
                        replaced at every Annual General Meeting. NO Member of the Governing Board shall serve
                        more than nine (9) years,with ineligibility period of twelve months.
                        <br/><br/>
                        Members of the Governing Board shall serve as such without remuneration and/or shall
                        directly or indirectly received no profit from occupying the position or providing services by
                        himself or herself or immediate family members to the corporation in another capacity.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>4.5 Vacancies</h5>
                    <p>
                        The Governing Board must, as soon as reasonable possible appoint through
                        the recommendation of the President, someone to fill any vacancy that occurs due to
                        resignation, expulsion, or death of a member or Members of the Governing Board.
                        Appointed person or persons shall hold office only until the next Annual General Meeting.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>4.6 Resignation, Disqualification, and Removal</h5>
                    <p>
                        A Member of the Governing Board
                        may resign from office in writing and upon acceptance by a majority vote of the Governing
                        Board. Disqualification of a Member of the Governing Board will occur upon termination of
                        membership to the corporation or becoming incapable by reason of prolonged illness. A
                        Member of the Governing Board can be removed from office through a two-thirds vote of
                        the remaining members consisting of not less than ten.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>4.7 Delegation of Powers</h5>
                    <p>
                        No Member of the Governing Board is allowed to delegate any
                        of their powers or functions to a committee or member of the corporation unless such
                        delegation and conditions are reflected in a Special Resolution that is passed by a majority
                        vote of the Governing Board.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>4.8 Conflict of Interest</h5>
                    <p>
                        Any actual, potential or perceived conflict of interest on the part
                        of all Members of the Governing Board, on a matter pertaining to the corporation, must be
                        disclosed in writing to the Governing Board which shall record as such conflict of interest in
                        the minutes of the first Board Meeting of the calendar year.
                        <br/><br/>
                        Failure to disclose and the effects thereof will be cause for immediate dismissal or removal
                        from the Governing Board.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>4.9 Confidentiality</h5>
                    <p>
                        All matters pertaining to litigation, security measures, contractual
                        negotiations, employment matters, details of proposed programs &amp; services, relationships
                        with other organizations, and other matters deemed confidential by the Governing Board,
                        must be treated as confidential and only the actual decisions may be disclosed to the
                        general public. Members of the Governing Board are not permitted, either during their
                        term of office or after, to use any confidential information they receive, or are privy to, for
                        their own purposes.
                        <br/><br/>
                        Any violation to this paragraph will be cause for immediate dismissal or removal from the
                        Governing Board.
                    </p>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>4.10 Duties of the Governing Board</h5>
                    <p>
                       Among others, the Governing Board shall execute,
                        without limitation, the following duties:
                    </p>
                    <ol type="a">
                        <li><p>
                            Safeguard and promote the objectives of the Corporation;
                        </p></li>
                        <li><p>
                            Solicit suggestions for cultural activities from various committees, organizations and
                            coordinate activities at the centre;
                        </p></li>
                        <li><p>
                            Give consideration to proposals submitted by the members and affiliate members and
                            take all reasonable steps to implement the proposals where appropriate;
                        </p></li>
                        <li><p>
                            Maintain and protect the property and assets of the Corporation;
                        </p></li>
                        <li><p>
                            Approve an annual budget consistent with the goal of proper management of the
                            Corporation;
                        </p></li>
                        <li><p>
                            Monitor timely payments of all expenses related to the operation and management of
                            the centre;
                        </p></li>
                        <li><p>
                            Prudently invest funds of the corporation which are regarded as idle and not
                            immediately required in such manner as it determines;
                        </p></li>
                        <li><p>
                            Borrow, raise, or secure the payment of money required to finance the operations of
                            the Corporation;
                        </p></li>
                        <li><p>
                            Develop and implement policies and procedures relating to the operation of the Centre
                            and the use of its facilities and assets;
                        </p></li>
                        <li><p>
                            Institute or defend any legal or other proceedings and to settle any claims against the
                            corporation; and
                        </p></li>
                        <li><p>
                            Carry out all the powers and authority of the corporation in Manitoba or Canada and in
                            any part of the world.
                        </p></li>
                    </ol>
                </div>
            </div>
        </>
    );
}

export default ArticleFour;